import React, { ChangeEvent, FormEvent, useState } from "react";
import axios from "axios";
import sharedStyles from "../../styles/shared.module.css";
import adminStyles from "../../styles/AdminProdutos.module.css";

const idiomaOptions = [
    { label: "English", value: "English" },
    { label: "Portuguese", value: "Portuguese" },
    { label: "Spanish", value: "Spanish" },
    { label: "French", value: "French" },
    { label: "German", value: "German" },
];

type Foto = { id: number; url: string };
type Servico = { id: number; nome: string };

type ProdutoFormProps = {
    titulo: string;
    setTitulo: (value: string) => void;
    descricao: string;
    setDescricao: (value: string) => void;

    /** ✅ agora preco é string */
    preco: string;
    setPreco: (value: string) => void;

    servicoId?: number;
    setServicoId: (value: number) => void;
    servicos: Servico[];
    duracao?: number;
    setDuracao: (value?: number) => void;
    idiomas: string[];
    setIdiomas: (value: string[]) => void;
    idadeMinima?: number;
    setIdadeMinima: (value?: number) => void;
    publicoAlvo: string;
    setPublicoAlvo: (value: string) => void;
    publicoLabels: Record<string, string>;

    fotos: File[];
    handleUploadFotos: (e: ChangeEvent<HTMLInputElement>) => void;
    handleRemoveFoto: (index: number) => void;

    editingProduto: { id?: number } | null;
    resetForm: () => void;
    BASE_URL: string;
    token: string;
};

const ProdutoForm = ({
    titulo, setTitulo,
    descricao, setDescricao,
    preco, setPreco,
    servicoId, setServicoId, servicos,
    duracao, setDuracao,
    idiomas, setIdiomas,
    idadeMinima, setIdadeMinima,
    publicoAlvo, setPublicoAlvo, publicoLabels,
    fotos, handleUploadFotos, handleRemoveFoto,
    editingProduto, resetForm,
    BASE_URL, token
}: ProdutoFormProps) => {

    const handleRemoveIdioma = (idioma: string) => {
        setIdiomas(idiomas.filter(i => i !== idioma));
    };

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();

        try {
            // Upload fotos
            const uploadedFotos: Foto[] = [];
            for (const file of fotos) {
                const formData = new FormData();
                formData.append("file", file);

                const res = await axios.post(`${BASE_URL}/uploads`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${token}`,
                    },
                });

                uploadedFotos.push(res.data);
            }

            // ✅ converte preco para número só aqui
            const precoBase = Number(preco);
            if (isNaN(precoBase) || precoBase <= 0) {
                alert("Informe um preço válido.");
                return;
            }

            const produtoData = {
                titulo,
                descricao,
                 precoBase: preco ? Number(preco) : 0,
                servicoId,
                duracaoEmMinutos: duracao,
                idadeMinima,
                publicoAlvo,
                idiomas,
                fotoIds: uploadedFotos.map((f) => f.id),
            };

            if (editingProduto) {
                await axios.put(
                    `${BASE_URL}/admins/produtos/${editingProduto.id}`,
                    produtoData,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
            } else {
                await axios.post(`${BASE_URL}/admins/produtos`, produtoData, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }

            resetForm();
        } catch (error) {
            console.error("Erro ao salvar produto:", error);
            alert("Erro ao salvar produto. Verifique o console.");
        }
    };

    return (
        <form onSubmit={handleSubmit} className={sharedStyles.form}>
            {/* Linha 1: Título e Serviço */}
            <div className={adminStyles.formSectionRow}>
                <div className={adminStyles.formGroupWide}>
                    <label>Título</label>
                    <input
                        type="text"
                        placeholder="Título"
                        value={titulo}
                        onChange={(e) => setTitulo(e.target.value)}
                        required
                    />
                </div>
                <div className={adminStyles.formGroup}>
                    <label>Serviço</label>
                    <select
                        value={servicoId}
                        onChange={(e) => setServicoId(Number(e.target.value))}
                        required
                    >
                        <option value="">Selecionar serviço</option>
                        {servicos.map((s) => (
                            <option key={s.id} value={s.id}>{s.nome}</option>
                        ))}
                    </select>
                </div>
            </div>

            {/* Linha 2: Preço, Duração, Idade mínima e Público */}
            <div className={adminStyles.formSectionRow}>
                <div className={adminStyles.formGroup}>
                    <label>Preço base</label>
                    <input
                        type="number"
                        placeholder="Preço"
                        value={preco}
                        onChange={(e) => setPreco(e.target.value)}
                        required
                    />
                </div>
                <div className={adminStyles.formGroup}>
                    <label>Duração (min)</label>
                    <input
                        type="number"
                        placeholder="Duração"
                        value={duracao ?? ""}
                        onChange={(e) => setDuracao(Number(e.target.value))}
                    />
                </div>
                <div className={adminStyles.formGroup}>
                    <label>Idade mínima</label>
                    <input
                        type="number"
                        placeholder="Idade mínima"
                        value={idadeMinima ?? ""}
                        onChange={(e) => setIdadeMinima(Number(e.target.value))}
                    />
                </div>
                <div className={adminStyles.formGroup}>
                    <label>Público-alvo</label>
                    <select
                        value={publicoAlvo}
                        onChange={(e) => setPublicoAlvo(e.target.value)}
                    >
                        <option value="">Selecionar público-alvo</option>
                        {Object.entries(publicoLabels).map(([key, label]) => (
                            <option key={key} value={key}>{String(label)}</option>
                        ))}
                    </select>
                </div>
            </div>

            {/* Descrição */}
            <div className={adminStyles.formSection}>
                <div className={adminStyles.formGroup}>
                    <label>Descrição</label>
                    <textarea
                        placeholder="Descrição"
                        value={descricao}
                        onChange={(e) => setDescricao(e.target.value)}
                        required
                    />
                </div>
            </div>

            {/* Idiomas */}
            <div className={adminStyles.formSection}>
                <label>Idiomas oferecidos</label>
                <div className={adminStyles.checkboxContainer}>
                    {idiomaOptions.map((idioma) => (
                        <label key={idioma.value} className={adminStyles.checkboxLabel}>
                            <input
                                type="checkbox"
                                value={idioma.value}
                                checked={idiomas.includes(idioma.value)}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setIdiomas([...idiomas, idioma.value]);
                                    } else {
                                        setIdiomas(idiomas.filter((i) => i !== idioma.value));
                                    }
                                }}
                            />
                            {idioma.label}
                        </label>
                    ))}
                </div>

                {/* Tags de idiomas */}
                <div className={adminStyles.tagsContainer}>
                    {idiomas.map((i) => (
                        <span key={i} className={adminStyles.tag}>
                            {i}{" "}
                            <button type="button" onClick={() => handleRemoveIdioma(i)}>❌</button>
                        </span>
                    ))}
                </div>
            </div>

            {/* Upload de Fotos */}
            <div className={adminStyles.formSection}>
                <label>Fotos do Produto</label>
                <div className={adminStyles.uploadContainer}>
                    <label className={adminStyles.uploadLabel}>
                        📷 Adicionar fotos
                        <input type="file" multiple onChange={handleUploadFotos} />
                    </label>
                    <div className={adminStyles.fotoPreview}>
                        {fotos.map((file, index) => (
                            <div key={index} className={adminStyles.fotoCard}>
                                <img src={URL.createObjectURL(file)} alt="Preview" />
                                <button
                                    type="button"
                                    className={adminStyles.removeFotoBtn}
                                    onClick={() => handleRemoveFoto(index)}
                                >
                                    ✕
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Botões */}
            <div className={adminStyles.formActions}>
                <button type="submit" className={sharedStyles.addButton}>
                    {editingProduto ? "Atualizar Produto" : "Adicionar Produto"}
                </button>
                {editingProduto && (
                    <button type="button" onClick={resetForm} className={sharedStyles.cancelButton}>
                        Cancelar
                    </button>
                )}
            </div>
        </form>
    );
};

export default ProdutoForm;
